var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSocialInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "nonzero",
    d: "M13.8125,1 C15.01875,1 16,1.98125 16,3.1875 L16,6.3125 L16,13.8125 C16,15.01875 15.01875,16 13.8125,16 L3.1875,16 C1.98125,16 1,15.01875 1,13.8125 L1,6.3125 L1,3.1875 C1,1.98125 1.98125,1 3.1875,1 L13.8125,1 Z M8.5,12.875 C10.9128125,12.875 12.875,10.9128125 12.875,8.5 C12.875,6.0871875 10.9128125,4.125 8.5,4.125 C6.0871875,4.125 4.125,6.0871875 4.125,8.5 C4.125,10.9128125 6.0871875,12.875 8.5,12.875 Z M8.5,6.625 C9.5340625,6.625 10.375,7.4659375 10.375,8.5 C10.375,9.5340625 9.5340625,10.375 8.5,10.375 C7.4659375,10.375 6.625,9.5340625 6.625,8.5 C6.625,7.4659375 7.4659375,6.625 8.5,6.625 Z M13.8125,4.75 C14.330267,4.75 14.75,4.33026695 14.75,3.8125 C14.75,3.29473305 14.330267,2.875 13.8125,2.875 C13.294733,2.875 12.875,3.29473305 12.875,3.8125 C12.875,4.33026695 13.294733,4.75 13.8125,4.75 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#FFF",
    fillOpacity: 0.01
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocialInstagram);
export default __webpack_public_path__ + "static/media/ic-social-instagram.014e8a8d4ef06e080a44538636c9f6ed.svg";
export { ForwardRef as ReactComponent };